import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledToastButton } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/components/FileUpload/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

type Props = {
    stateName: IRouterState["name"];
    params: { domain: string | undefined; [key: string]: unknown };
};

export const FileToast: React.FC<Props> = ({ stateName, params }) => {
    const paramsCopy = { ...params, domain: params.domain ?? null };

    const handleToastButtonClick = () => {
        if (stateName) {
            void proNavigator.go(stateName, { ...paramsCopy, isSettingsOpen: true });
        }
    };

    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[0]}
            >
                {translate("si.agent_knowledge_base.modal.file.toast.message")}
            </Text>
            <StyledToastButton
                type="flat"
                onClick={handleToastButtonClick}
            >
                {translate("si.agent_knowledge_base.modal.file.toast.button")}
            </StyledToastButton>
        </Flex>
    );
};
